<script lang="ts">
export let text: string
</script>

<h5>{text}</h5>

<style lang="scss">
h5 {
  text-transform: uppercase;
  font-size: 17px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 1.28px;
  margin: 0;
}
</style>
